const previews = new Map();

class ShopBestSellers extends HTMLElement {
  connectedCallback() {
    if (this.loaded) return;
    this.observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        this.observer?.disconnect();
        this.loadProducts();
      }
    });
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  async loadProducts() {
    const target = this.querySelector('[data-products]');
    const rawUrl = (this.dataset.url || '').replace(/&amp;/g, '&');
    if (!target || this.loaded || this.loading || !rawUrl) return;

    this.loading = true;
    this.observer?.disconnect();

    try {
      const url = new URL(rawUrl, window.location.origin);
      if (url.origin !== window.location.origin) {
        throw new Error('Expected a store collection');
      }

      if (!previews.has(url.href)) {
        const request = fetch(url.href)
          .then((response) => {
            if (!response.ok) throw new Error('Collection request failed');
            return response.text();
          })
          .catch((error) => {
            previews.delete(url.href);
            throw error;
          });
        previews.set(url.href, request);
      }

      const html = await previews.get(url.href);
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const content = parsed.querySelector('[data-best-sellers-content]');
      if (!content) throw new Error('Missing collection preview');

      // Sanitize: ensure no nested <a> tags or unwanted app widgets exist inside cards
      const cards = content.querySelectorAll('.mega-menu__subcategory-card');
      cards.forEach((card) => {
        const nestedLinks = card.querySelectorAll('a');
        nestedLinks.forEach((a) => {
          const span = document.createElement('span');
          span.className = a.className;
          span.innerHTML = a.innerHTML;
          a.replaceWith(span);
        });
        const kokoElements = card.querySelectorAll('.koko-installments');
        kokoElements.forEach((el) => el.remove());
      });

      target.innerHTML = '';
      target.appendChild(document.importNode(content, true));
      this.loaded = true;

      requestAnimationFrame(() => {
        const submenu = this.closest('.menu-list__submenu');
        const header = document.querySelector('header-component');
        if (
          submenu instanceof HTMLElement &&
          header instanceof HTMLElement &&
          header.getAttribute('data-menu-expanded') === 'true' &&
          submenu.offsetHeight > 0
        ) {
          header.style.setProperty('--submenu-height', `${submenu.offsetHeight}px`);
          const topRow = header.querySelector('.header__row--top');
          const topRowHeight = topRow instanceof HTMLElement ? topRow.offsetHeight : header.offsetHeight;
          const fullOpen = topRowHeight + submenu.offsetHeight;
          header.style.setProperty('--full-open-header-height', `${fullOpen}px`);
        }
      });
    } catch (error) {
      console.warn('[ShopBestSellers] Could not load preview:', error);
      this.loaded = false;
      target.textContent = 'Browse the collection to see its best sellers.';
    } finally {
      this.loading = false;
      target.setAttribute('aria-busy', 'false');
    }
  }
}

if (!customElements.get('shop-best-sellers')) {
  customElements.define('shop-best-sellers', ShopBestSellers);
}
